import logo from './logo.svg';
import './App.css';
import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

const Home = (props) => <div>首页 - {props.loggedInUser?.name || '未登录'}</div>;
const Auth = (props) => <div>登录/注册页</div>;
const PostDetail = () => <div>文章详情页</div>;
const Archive = () => <div>归档页</div>;
const About = () => <div>关于页</div>;
const WritePost = () => <div>写文章页</div>;
const NotFound = () => <div>404页面</div>;

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [aboutInfo, setAboutInfo] = useState({});
  const [aboutLoading, setAboutLoading] = useState(false);

  // 4. 新增路由依赖的函数（核心，先空实现，后续补逻辑）
  const handleLogin = (userInfo) => setLoggedInUser(userInfo);
  const handleRegister = (userInfo) => setLoggedInUser(userInfo);
  const handleLogout = () => setLoggedInUser(null);
  const handleAddPost = (newPost) => setPosts([...posts, newPost]);
  const handleUpdateAboutInfo = (newInfo) => setAboutInfo(newInfo);

  
  return (
    <div className="App">
      
      {/*<header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
      </header>*/}
      <Router>
      <Routes>
        <Route
          path="/"
          element={
            loggedInUser ? (
              <Home posts={posts} loading={loading} error={error} loggedInUser={loggedInUser} onLogout={handleLogout} />
            ) : (
                <Auth
                  onLogin={handleLogin}
                  onRegister={handleRegister}
                  loggedInUser={loggedInUser}
                  onLogout={handleLogout}
                />
            )
          }
        />

        <Route
          path="/auth"
          element={
            <Auth
              onLogin={handleLogin}
              onRegister={handleRegister}
              loggedInUser={loggedInUser}
              onLogout={handleLogout}
            />
          }
        />

        <Route
          path="/post/:id"
          element={
              <PostDetail
                  posts={posts}
                  loggedInUser={loggedInUser}
                  onLogout={handleLogout}
              />
          }
        />
        <Route
            path="/archive"
            element={
                <Archive posts={posts} loading={loading} error={error} loggedInUser={loggedInUser} onLogout={handleLogout} />
            }
        />

        <Route
          path="/about"
          element={
            <About
              aboutInfo={aboutInfo}
              onUpdateAboutInfo={handleUpdateAboutInfo}
              loading={aboutLoading}
              canEdit={!!loggedInUser}
              onLogout={handleLogout}
              loggedInUser={loggedInUser}
            />
          }
        />

        <Route
          path="/write"
          element={
            loggedInUser ? (
              <WritePost
                onAddPost={handleAddPost}
                posts={posts}
                loggedInUser={loggedInUser}
                onLogout={handleLogout}
              />
            ) : (
              <Navigate to="/auth" replace />
            )
          }
        />

        <Route
            path="*"
            element={
                <NotFound loggedInUser={loggedInUser} onLogout={handleLogout} />
            }
        />
      </Routes>
    </Router>
    </div>
  );
}

export default App;
